<template>
	<div class="radarView" ref="radars"></div>
</template>

<script>
// 引入基本模板
let echarts = require('echarts/lib/echarts')
// 引入柱状图组件
require('echarts/lib/chart/radar')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
export default {
	name: 'radarView',
	props: ['data', 'total', 'tip', 'color'],
	methods: {
		drawChart () {
			this.$nextTick(() => {
				let newD = this.data.data.map(item => {
					if (item === null || item === 0) {
						return 0
					}
					return (parseInt(((item / this.total) * 100) === parseFloat((item / this.total) * 100)) ? (item / this.total) * 100 : ((item / this.total) * 100).toFixed(2))
				})
				// 基于准备好的dom，初始化echarts实例
				let myChart = echarts.init(this.$refs.radars, null, {devicePixelRatio: 2.5})
				myChart.setOption({
					tooltip: {
						trigger: 'axis',
						formatter: (params) => {
							var str = '<h3 style="margin-bottom:6px">' + params.name + '</h3>'
							this.data.text.map((item, index) => {
								str += item.text + ' : ' + newD[index] + '%<br>'
							})
							return str;
						}
					},
					radar: [
						{
							indicator: this.data.text,
							center: ['50%', '50%'],
							radius: 60
						}
					],
					series: [
						{
							type: 'radar',
							tooltip: {
								trigger: 'item'
							},
							areaStyle: {
								color: this.color
							},
							lineStyle: {
								color: this.color
							},
							itemStyle: {
								color: this.color
							},
							data: [
								{
									value: newD,
									name: this.tip
								}
							]
						}
					]
				})
				window.addEventListener("resize",function(){
          myChart.resize();
        });
			})
    }
	},
	watch: {
		data () {
			this.drawChart()
		}
	},
	mounted () {
		this.drawChart()
	}
}
</script>

<style scoped>
.radarView {
	width: 100%;
	height: 200px;
	background: #ffffff;
}
</style>
